import { render, staticRenderFns } from "./AddEditPermission.vue?vue&type=template&id=f1015d8e&"
import script from "./AddEditPermission.vue?vue&type=script&lang=js&"
export * from "./AddEditPermission.vue?vue&type=script&lang=js&"
import style0 from "./AddEditPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports